import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Text } from 'rebass';
import Entry from '../entry';

export default () => {
  const title = '0. Talk to Santa in the Quad';
  const hints = [];
  const assignment = 'Enter the campus quad and talk to Santa.';
  const data = useStaticQuery(graphql`
    query {
      withSanta: file(relativePath: { eq: "withSanta.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)

  return (
    <Entry
      title={title}
      hints={hints}
      assignment={assignment}
    >
      <Text my={2}> Santa is located in front of us as soon as we enter the Quad from the Train Station. </Text>
      <Img fluid={data.withSanta.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh' }}
              imgStyle={{ objectFit: 'contain' }}
      />

    </Entry>
  )

};
